import { FormEvent } from 'react'
import { useNavigate, useParams } from 'react-router'
import { ObjectTypes, useObjectCreate } from '../api/object'
import { ObjectForm } from './object-form'

export function ObjectCreate() {
	const navigate = useNavigate()
	const { object } = useParams<{ object: keyof ObjectTypes }>()
	if (!object) throw new Error('Invalid invocation')

	const { mutate, isPending } = useObjectCreate(object)

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form), {
			onSuccess: () => {
				form.reset()
				navigate('../')
			},
		})
	}

	return <ObjectForm object={object} onSubmit={onSubmit} isPending={isPending} />
}
